<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    ></BlockUI>
    <v-card>
      <v-card-title>
        Carteira
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        no-data-text="Nenhuma carteira registrada"
        footer-props.items-per-page-text="Linhas por página"
        :headers="fields"
        :items="walletEventsData"
        :search="search"
        class="table-custom-vue elevation-1 mt-2"
        :rows-per-page-items="[
          10,
          25,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <template v-slot:item.value="{ item }">
          <div>R$ {{ item.value | formatPrice }}</div>
        </template>
        <template v-slot:item.created_at="{ item }">
          <div>{{ item.created_at | formatData }}</div>
        </template>
        <template v-slot:item.updated_at="{ item }">
          <div>{{ item.updated_at | formatData }}</div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import WalletController from '../../controllers/WalletController';
import NumberHelper from './../../helpers/NumberHelper';
import ModalPadrao from '../shared/ModalPadrao.vue';
import Breadcrumb from '../shared/Breadcrumb.vue';
import ActionButton from '../shared/ActionButtonsTemplate';
import moment from 'moment';

export default {
  created() {
    this.getWalletEvents();
  },
  components: {
    ActionButton,
    ModalPadrao,
    Breadcrumb,
  },
  data() {
    return {
      walletController: new WalletController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      fields: [
        {
          value: 'id',
          text: 'ID',
        },
        {
          value: 'type',
          text: 'Tipo',
        },
        {
          value: 'value',
          text: 'Valor',
        },
        {
          value: 'transaction_id',
          text: 'Transação ID',
        },
        {
          value: 'vehicle_request_id',
          text: 'Reserva ID',
        },
        {
          value: 'created_at',
          text: 'Data Criação',
        },
        {
          value: 'updated_at',
          text: 'Data Atualização',
        },
      ],
      walletEventsData: [],
      walletId: this.$route.params.id,
    };
  },
  methods: {
    getWalletEvents() {
      this.blockScreen = true;
      this.walletController
        .getWalletEvents(this.walletId)
        .then(res => {
          this.walletEventsData = res;
        })
        .finally(() => (this.blockScreen = false));
    },
  },
  filters: {
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    formatData(value) {
      return moment(value).format('DD[/]MM[/]YYYY HH:mm:ss');
    },
  },
};
</script>
<style lang="scss">
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
